<div class="maincontentarea">
    <div class="container">
       <div class="row">
           <div class="col-sm-12">
               <h1 class="_dummy_t">There is no content</h1>
           </div>
       </div>
    </div>
   </div>